/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import nodeLogo from '@/assets/boiler.png'

function BoilerNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={nodeLogo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Boiler</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Right} />
    </div>
  )
}

export default BoilerNode
